// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"0":"81f09a27","202":"ef0c08d3","274":"8ca5e8a0","760":"2d637ed6","882":"8ad8853a"}[chunkId] + ".chunk.js";
};